import React, { useState } from 'react'
import styles from './resetPasswordRequest.module.css'
import { NavLink, useNavigate } from 'react-router-dom'
import * as v from 'valibot'
import { useForm } from 'react-hook-form'
import { valibotResolver } from '@hookform/resolvers/valibot'
import { useResetPasswordMutation } from '../../../features/api/user/userApi'
import { Input } from '../../common/input/Input'

const schema = v.object({
  email: v.pipe(
    v.string(),
    v.nonEmpty('Please enter you email'),
    v.email('The email address is incorrect'),
    v.maxLength(50, 'Email address is too long')
  ),
})
export const ResetPasswordRequest = () => {
  const [serverErr, setServerErr] = useState(false)
  const [userNotExist, setUserNotExist] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: '',
    },
    resolver: valibotResolver(schema),
  })
  const navigate = useNavigate()

  const [resetPassword, { isLoading, isSuccess }] = useResetPasswordMutation()

  const onSubmit = async (userInfo) => {
    try {
      await resetPassword(userInfo).unwrap()
      setTimeout(() => {
        navigate('/')
      }, 5000)
    } catch (err) {
      if (err?.data?.errorCode === 400) {
        userNotExistsErr()
      } else {
        setServerErr(true)
      }
    }
  }

  const userNotExistsErr = () => {
    setUserNotExist(true)
    setTimeout(() => {
      setUserNotExist(false)
    }, 3000)
  }
  return (
    <div className={styles.reset_password_container}>
      <form
        className={styles.reset_password_form}
        onSubmit={handleSubmit(onSubmit)}
      >
        <section>
          <Input
            label='E-mail'
            field='email'
            register={register}
            error={errors.email}
            color='#ffffff'
          />
        </section>
        <section className={styles.submit_btn_info}>
          <button type='submit' disabled={isLoading}>
            {isLoading ? 'In progress...' : 'Reinitialise'}
          </button>
          {userNotExist && (
            <p className={`${styles.reset_info} ${styles.err_msg}`}>
              User does not exist
            </p>
          )}

          {serverErr && (
            <p className={`${styles.reset_info} ${styles.err_msg}`}>
              An error occured, please try agin
            </p>
          )}
          {isSuccess && (
            <p className={`${styles.reset_info} ${styles.success_msg}`}>
              Please check your email to complete the process
            </p>
          )}
        </section>
        <ul className={styles.redirect_btn_group}>
          <li>
            <NavLink to='/'>Log in</NavLink>
          </li>
        </ul>
      </form>
    </div>
  )
}
